export const FETCH_EVENT_REGISTRATIONS_START =
  'FETCH_EVENT_REGISTRATIONS_START';
export const FETCH_EVENT_REGISTRATIONS_SUCCESS =
  'FETCH_EVENT_REGISTRATIONS_SUCCESS';
export const FETCH_EVENT_REGISTRATIONS_FAIL = 'FETCH_EVENT_REGISTRATIONS_FAIL';
export const RESET_FETCH_EVENT_REGISTRATIONS_STORE =
  'RESET_FETCH_EVENT_REGISTRATIONS_STORE';

export const CREATE_EVENT_REGISTRATION_START =
  'CREATE_EVENT_REGISTRATION_START';
export const CREATE_EVENT_REGISTRATION_SUCCESS =
  'CREATE_EVENT_REGISTRATION_SUCCESS';
export const CREATE_EVENT_REGISTRATION_FAIL = 'CREATE_EVENT_REGISTRATION_FAIL';
export const RESET_CREATE_EVENT_REGISTRATION_STORE =
  'RESET_CREATE_EVENT_REGISTRATION_STORE';

export const UPDATE_EVENT_REGISTRATION_START =
  'UPDATE_EVENT_REGISTRATION_START';
export const UPDATE_EVENT_REGISTRATION_SUCCESS =
  'UPDATE_EVENT_REGISTRATION_SUCCESS';
export const UPDATE_EVENT_REGISTRATION_FAIL = 'UPDATE_EVENT_REGISTRATION_FAIL';
export const RESET_UPDATE_EVENT_REGISTRATION_STORE =
  'RESET_UPDATE_EVENT_REGISTRATION_STORE';

export const DELETE_MULTIPLE_EVENT_REGISTRATIONS_START =
  'DELETE_MULTIPLE_EVENT_REGISTRATIONS_START';
export const DELETE_MULTIPLE_EVENT_REGISTRATIONS_SUCCESS =
  'DELETE_MULTIPLE_EVENT_REGISTRATIONS_SUCCESS';
export const DELETE_MULTIPLE_EVENT_REGISTRATIONS_FAIL =
  'DELETE_MULTIPLE_EVENT_REGISTRATIONS_FAIL';
export const RESET_DELETE_MULTIPLE_EVENT_REGISTRATIONS_STORE =
  'RESET_DELETE_MULTIPLE_EVENT_REGISTRATIONS_STORE';

export const DELETE_EVENT_REGISTRATION_START =
  'DELETE_EVENT_REGISTRATION_START';
export const DELETE_EVENT_REGISTRATION_SUCCESS =
  'DELETE_EVENT_REGISTRATION_SUCCESS';
export const DELETE_EVENT_REGISTRATION_FAIL = 'DELETE_EVENT_REGISTRATION_FAIL';
export const RESET_DELETE_EVENT_REGISTRATION_STORE =
  'RESET_DELETE_EVENT_REGISTRATION_STORE';

export const RESET_EVENT_REGISTRATION_STORE = 'RESET_EVENT_REGISTRATION_STORE';

export type EventRegistrationActionTypes =
  | typeof FETCH_EVENT_REGISTRATIONS_START
  | typeof FETCH_EVENT_REGISTRATIONS_SUCCESS
  | typeof FETCH_EVENT_REGISTRATIONS_FAIL
  | typeof CREATE_EVENT_REGISTRATION_START
  | typeof CREATE_EVENT_REGISTRATION_SUCCESS
  | typeof CREATE_EVENT_REGISTRATION_FAIL
  | typeof RESET_CREATE_EVENT_REGISTRATION_STORE
  | typeof UPDATE_EVENT_REGISTRATION_START
  | typeof UPDATE_EVENT_REGISTRATION_SUCCESS
  | typeof UPDATE_EVENT_REGISTRATION_FAIL
  | typeof RESET_UPDATE_EVENT_REGISTRATION_STORE
  | typeof RESET_FETCH_EVENT_REGISTRATIONS_STORE
  | typeof DELETE_MULTIPLE_EVENT_REGISTRATIONS_START
  | typeof DELETE_MULTIPLE_EVENT_REGISTRATIONS_SUCCESS
  | typeof DELETE_MULTIPLE_EVENT_REGISTRATIONS_FAIL
  | typeof RESET_DELETE_MULTIPLE_EVENT_REGISTRATIONS_STORE
  | typeof DELETE_EVENT_REGISTRATION_START
  | typeof DELETE_EVENT_REGISTRATION_SUCCESS
  | typeof DELETE_EVENT_REGISTRATION_FAIL
  | typeof RESET_DELETE_EVENT_REGISTRATION_STORE
  | typeof RESET_EVENT_REGISTRATION_STORE;
